// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610132135/js/" + chunkId + "." + {"44":"646e48d2","225":"d2ba7e37","481":"e281e35a","486":"96dac409","770":"8d7da9a9"}[chunkId] + ".0.04487832506140377.chunk.js";
};